import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GUsersService {

  constructor(private http: HttpClient) { }

  GetGroupUsers() { 
    return this.http.get(environment.api_url + 'api/v1.0/groups/listusers')
  }
  
  AddGroupAdmin(id, body) {
    return this.http.post(environment.api_url + 'api/v1.0/groups/' + id +'/addadmintogroup', body )
  }
  AddGroupUser(body) {
    return this.http.post(environment.api_url + 'api/v1.0/mangroups/addusertogroup', body )
  }
  DeleteGroupAdmin(id: string) {
    return this.http.delete(environment.api_url + 'api/v1.0/groups/' + id + '/removeadminfromgroup');
  }
  DeleteUserFromGroup(id: string) {
    return this.http.delete(environment.api_url + 'api/v1.0/mangroups/id/' + id + '/removeuserfromgroup')
  }

}
